import React, { useContext } from 'react';
//import CartNotification from 'components/navbar/top/CartNotification';
//import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
import ProfileDropdown from '../../../components/navbar/top/ProfileDropdown';
import { Nav } from 'react-bootstrap';
//import NineDotMenu from './NineDotMenu';
//import ThemeControlDropdown from './ThemeControlDropdown';
import { AuthContext } from '../../../contexts/AuthContext';

const TopNavRightSideNavItem = () => {
  const { usuario, empresa } = useContext(AuthContext);

  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <div>
        <span className='text-light'> {usuario} / {empresa}  </span>
        {/* {usuario} / {empresa} */}
      </div>
      {/* <ThemeControlDropdown /> */}
      {/* <CartNotification /> */}
      {/* <NotificationDropdown /> */}
      {/* <NineDotMenu /> */}
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
